<script setup>
  import { toRefs } from 'vue';
  import { Authenticator, useAuthenticator } from '@aws-amplify/ui-vue';
  // `route` `user` and `signOut` all are reactive.
  const { route, user, signOut } = toRefs(useAuthenticator());
</script>
<template>
  <!-- Header Menu -->
  <ul class="nav user-menu">
    <!-- Search -->
    <li class="nav-item nav-searchinputs">
      <div class="top-nav-search">
        
      </div>
    </li>
    <!-- /Search -->
    
    <!-- /Flag -->
    <li class="nav-item nav-item-box">
      <a href="javascript:void(0);" id="btnFullscreen" @click="initFullScreen">
        <vue-feather type="maximize"></vue-feather>
      </a>
    </li>
    <!--<li class="nav-item nav-item-box">
      <router-link to="generalsettings"
        ><vue-feather type="settings"></vue-feather
      ></router-link>
    </li>-->
    <template v-if="user">
    <li class="nav-item dropdown has-arrow main-drop">
      <a
        href="javascript:void(0);"
        class="dropdown-toggle nav-link userset"
        data-bs-toggle="dropdown"
      >
        <span class="user-info">
          <span class="user-letter">
            <img src="../assets/img/profiles/avator1.jpg" alt="" class="img-fluid" />
          </span>
          <span class="user-detail">
            <span class="user-name">{{user.attributes.name}}</span>
            <span class="user-role">{{user.attributes['custom:role']}}</span>
          </span>
        </span>
      </a>
      <div class="dropdown-menu menu-drop-user">
        <div class="profilename">
          <div class="profileset">
            <span class="user-img"
              ><img src="../assets/img/profiles/avator1.jpg" alt="" />
              <span class="status online"></span
            ></span>
            <div class="profilesets">
              <h6>{{user.attributes.name}}</h6>
              <h5>{{user.attributes['custom:role']}}</h5>
            </div>
          </div>
          <hr class="m-0" />
          <!--<router-link class="dropdown-item" to="profile"
            ><vue-feather type="user"></vue-feather>My Profile</router-link
          >
          <router-link class="dropdown-item" to="generalsettings"
            ><vue-feather type="settings"></vue-feather>Settings</router-link
          >-->
          <hr class="m-0" />
          <router-link class="dropdown-item logout pb-0" @click="signOut" to="/"
            ><img
              src="../assets/img/icons/log-out.svg"
              class="me-2"
              alt="img"
              
            />Logout</router-link
          >
        </div>
      </div>
    </li>
    </template>
  </ul>
  <!-- /Header Menu -->
</template>
<script>
import { Auth } from 'aws-amplify';
import headernotification from "../assets/json/headernotification.json";
export default {
  data() {
    return {
      fullname: '',
      user: ''
    };
  },
  methods: {
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setUserAttr() {
      userattrs = user.userattributes;
      for (var attr in userattrs) {
        if (attr.name == 'name') {
          this.fullname = attr.name;
        }
      }
    },
    signOut() {
      Auth.signOut()
      .then(data => {
      }).catch(err => console.log(err))
    }
  },
  beforeMount() {
    //this.setUserAttr()
  }
};
</script>
